import { Link } from "@tanstack/react-router";
import logoWhite from "@/assets/opt/logo-white-176.webp";
import logoBlack from "@/assets/opt/logo-black-176.webp";

// Intrinsic sizes of the optimised marks. Used to keep the rendered
// width/height at the real aspect ratio (Lighthouse image-aspect-ratio).
const MARK = {
  black: { src: logoBlack, w: 176, h: 170 },
  white: { src: logoWhite, w: 176, h: 176 },
} as const;

type Props = {
  className?: string;
  asLink?: boolean;
  size?: number;
  /** When true, render the white mark (for dark surfaces). Otherwise the black mark. */
  onDark?: boolean;
};

/**
 * Tailor's Barber logo. White on dark surfaces, black on light surfaces.
 */
export function Logo({ className = "", asLink = true, size = 44, onDark = false }: Props) {
  const mark = onDark ? MARK.white : MARK.black;
  const height = Math.round((size * mark.h) / mark.w);
  const img = (
    <img
      src={mark.src}
      alt="Tailor's Barber"
      width={size}
      height={height}
      className={["block select-none", className].filter(Boolean).join(" ")}
      style={{ height, width: size }}
      loading="eager"
      decoding="async"
    />
  );


  if (!asLink) return img;
  return (
    <Link to="/" aria-label="Tailor's Barber – hem" className="inline-flex items-center">
      {img}
    </Link>
  );
}
